<div class="white-box main-black mt-4 p-4 border-radius" *ngIf="ddList.years.length > 0">
	<div class="row">
		<div class="col">
			<h4>{{title}}</h4>
		</div>
	</div>
	<div class="row py-4">
		<div class="col-sm-6 col-md-4 col-lg-2 d-inline-flex">
			<ng-select
				class="mr-auto w-100"
				[searchable]="false"
				[items]="ddList.years"
				bindLabel="label"
				bindValue="id"
				placeholder="{{'g.year' | translate}}"
				name="battery_usage_year"
				[(ngModel)]="selectedYear"
				(ngModelChange)="onFilterChange()"
				[clearable]="false"
			>
			</ng-select>
		</div>
		<div class="col-sm-6 col-md-4 col-lg-2 d-inline-flex" *ngIf="!isAllYears">
			<ng-select
				class="mr-auto w-100"
				[searchable]="false"
				[items]="monthlyQuarterlyPeriods"
				bindLabel="durations"
				bindValue="id"
				placeholder="{{'g.durations' | translate}}"
				name="battery_usage_duration"
				[(ngModel)]="selectedDuration"
				(ngModelChange)="onFilterChange()"
				[clearable]="false"
			>
			</ng-select>
		</div>
		<div class="col-sm-6 col-md-4 col-lg-2 d-inline-flex" *ngIf="!isAllYears && ddList.periods.length > 0">
			<ng-select
				class="mr-auto w-100"
				[searchable]="false"
				[items]="ddList.periods"
				bindLabel="label"
				bindValue="id"
				placeholder="{{'customer.charts.period' | translate}}"
				name="battery_usage_period"
				[(ngModel)]="selectedPeriod"
				(ngModelChange)="onFilterChange()"
				[clearable]="false"
			>
			</ng-select>
		</div>
		<div class="col-sm-6 col-md-4 col-lg-2 d-inline-flex" *ngIf="sites.length > 0">
			<ng-select
				class="mr-auto w-100"
				[searchable]="false"
				[items]="sites"
				bindLabel="name"
				bindValue="id"
				placeholder="{{'site.all_sites' | translate}}"
				name="battery_usage_sites"
				[(ngModel)]="selectedSites"
				(ngModelChange)="onFilterChange()"
				[multiple]="true"
			>
			</ng-select>
		</div>
	</div>

	<!-- ST-2448: one legend under the filters, as on the Truck Utilization charts -->
	<div class="row py-4" *ngIf="showChart && chartLegend.length > 0">
		<div class="font-size-12 ml-3" *ngFor="let entry of chartLegend">
			<div class="chartLegend mr-1" [ngStyle]="{'background-color': entry.color}"></div><b>{{entry.text}}</b>
		</div>
	</div>
	<div *ngIf="showChart">
		<div *ngFor="let chart of charts" class="mb-4">
			<div class="row">
				<div class="col d-inline-flex ml-auto justify-content-end" [ngClass]="{'pt-2': common.isMobileScreen}">
					<button
						class="btn fa fa-print fa-lg"
						printTitle="{{chart.title}}"
						[useExistingCss]="true"
						[printSectionId]="chart.printSectionId"
						ngxPrint
						title="{{'g.print' | translate}}"
					></button>
					<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportChart(chart)"></button>
				</div>
			</div>
			<div [id]="chart.printSectionId">
				<app-print-filters [title]="chart.title" [filters]="printFilters"></app-print-filters>
				<!-- ST-2614: up to 36 bars fill the page; with more the chart widens and scrolls sideways. The box only scrolls when it has to: a chart drawn a scrollbar's width too wide must not get a scrollbar -->
				<div [style.overflow]="chart.widthPercent > 100 ? 'auto hidden' : 'visible'">
					<div [style.width.%]="chart.widthPercent">
						<sct-charts
							[id]="chart.printSectionId + '-values'"
							[title]="chart.title"
							[data]="chart.rows"
							[columnNames]="chart.columnNames"
							[options]="chart.config"
							[type]="'ColumnChart'"
							[height]="500"
						></sct-charts>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div *ngIf="!showChart" class="mt-4 alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</div>
